<template>
  <div class="d-flex">
    <div class="py-2 px-1 col-11">
      <ClientSelect
        v-model="clients"
        :multiple-select="true"
        :partnership-stopped="true"
      />
    </div>
    <div class="pr-0 py-3 col-1">
      <v-btn
        icon
        class="mx-0"
        @click="$emit('apply', clients)"
      >
        <v-icon color="green lighten-2">
          check
        </v-icon>
      </v-btn>

      <v-btn
        icon
        class="mx-0"
        @click="$emit('cancel')"
      >
        <v-icon color="red lighten-2">
          close
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import ClientSelect from "../../../components/selects/ClientSelect.vue";

export default {
  components: {
    ClientSelect,
  },
  data: () => ({
    clients: [],
  }),
};
</script>
